import React from 'react';
import PropTypes from 'prop-types';
import Warning from 'jsx/elements/messages/Warning';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import { splitSsn } from 'utils/strings';

function ExclusionUploadResult({ data, onClose, isOpen }) {
  const { t } = useLocale();
  const styling = {
    maxHeight: '0px',
    overflowY: 'hidden',
    transition: 'all .6s',
  };
  if (isOpen) {
    styling.maxHeight = '500px';
  }

  let broken = {};
  let valid = [];
  data &&
    data.forEach((d) => {
      if (d.validationError !== null) {
        const errorID = d.validationError.validationErrorID;
        if (broken[errorID]) {
          broken[errorID].push(d);
        } else {
          broken[errorID] = [d];
        }
      } else {
        valid.push(d);
      }
    });

  const brokenKeys = Object.keys(broken);

  return (
    <div style={styling}>
      <Warning
        messageHeader={t('portfolio_exclusionUploadResult_header')}
        messageType="info"
        extraClass="no-gutter-bottom"
        onClose={onClose}
      />
      <div style={{ padding: '20px' }} className="box no-shadow">
        {valid.length > 0 && (
          <div className="text-14">
            <div className="text-bold">{t('portfolio_exclusionUploadResult_valid_regnos')}</div>
            <p>{t('exclusionUploadResult_n_successful', valid.length)}</p>
          </div>
        )}
        {brokenKeys.length > 0 && (
          <div>
            {valid.length > 0 && (
              <div className="gutter-top">
                <div className="divider" />
              </div>
            )}
            <div className="text-14 text-bold">
              {t('portfolio_exclusionUploadResult_invalid_regnos')}
            </div>
            {brokenKeys.map((k) => {
              return (
                <div className="text-14" key={k}>
                  <span className="text-semibold">
                    {t(`exclusionUploadResult_error_${k}`) + ': '}
                  </span>
                  {broken[k].map((r, i) => {
                    if (i === broken[k].length - 1) {
                      return <span key={i}>{splitSsn(r.keyword)}</span>;
                    }
                    return <span key={i}>{splitSsn(r.keyword) + ', '}</span>;
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

ExclusionUploadResult.propTypes = {
  data: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default ExclusionUploadResult;
